import { ModalHeader } from '../ModalStyles'

const EmailSent = () => {
	return (
		<ModalHeader>Request Received, an Email is on its way</ModalHeader>
	)
}

export default EmailSent